<template>
  <div>
    <div
      class="border-s-300 lg:border-s-500 mb-3 border-b pb-3 text-sm font-semibold"
      :class="[isModal ? 'w-full' : 'w-auto']"
    >
      <div
        class="flex w-auto flex-row-reverse items-center gap-x-2 lg:flex-row"
      >
        <input
          :id="filter.name"
          :checked="headerValue"
          :disabled="filter.disabled"
          type="checkbox"
          class="form-checkbox border-s-900 text-s-900 disabled:bg-s-400 lg:border-s-500 lg:text-p-500 mr-2 h-4 w-4 cursor-pointer border-2 border-solid focus:shadow-none focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed"
          @input="changeHeader"
        />
        <div class="font-montserrat text-s-900 w-full lg:w-max lg:text-white">
          {{ header }}
        </div>
      </div>
    </div>
    <div class="space-y-5 lg:mb-4 lg:space-y-1">
      <div v-for="option in options" :key="option.data.name">
        <div class="flex items-center">
          <label
            class="flex w-max flex-grow cursor-pointer flex-row-reverse items-center lg:flex-grow-0 lg:flex-row"
          >
            <input
              :id="option.data.name"
              :checked="option.checked"
              :disabled="option.disabled"
              type="checkbox"
              class="form-checkbox border-s-500 text-s-900 disabled:bg-s-400 lg:text-p-500 mr-2 h-4 w-4 cursor-pointer border-2 border-solid focus:shadow-none focus:ring-0 focus:ring-offset-0 disabled:cursor-not-allowed"
              @input="changeOption(option, $event)"
            />
            <span
              class="text-s-900 w-full text-sm font-semibold lg:ml-3 lg:text-white"
            >
              {{ getLabel(option.data) }}
            </span>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    filter: {
      name: string
      label?: string
      checked: boolean
      disabled?: boolean
      options: Array<{
        data: {
          name: string
          label?: string
          isSustainable?: boolean
        }
        checked: boolean
        disabled?: boolean
      }>
    }
    isModal?: boolean
  }>(),
  {
    isModal: false,
  },
)

const emit = defineEmits(['changeOptions', 'updated-header'])

const header = computed(() => props.filter.label ?? props.filter.name)
const headerValue = computed(() => props.filter.checked)
const options = computed(() => props.filter.options)

const changeHeader = (event) => {
  emit('updated-header', {
    name: header.value,
    value: event.target.checked,
  })
}

const changeOption = (option, event) => {
  emit('changeOptions', {
    level: header.value,
    name: option.data.name,
    value: event.target.checked,
  })
}

const getLabel = (data) => {
  const label = data.label || data.name
  return data?.isSustainable ? `${label} Sustainable` : label
}
</script>
